module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-centerInfo",
    staticStyle: {
      "background-color": "#f7f8fa"
    }
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('centerinfo_title'),
      "url": "/opera/center",
      "replace": "true"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "perInfo"
  }, [_c('mt-cell', {
    attrs: {
      "title": _vm.$t('centerinfo_code'),
      "value": _vm.perInfo.code
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('hotelGroupName'),
      "value": _vm.perInfo.hotelGroupName
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('hotelName'),
      "value": _vm.perInfo.hotelName
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('bizDate'),
      "value": _vm._f("dateF")(_vm.perInfo.bizDate)
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('name'),
      "value": _vm.perInfo.name
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('sex'),
      "value": _vm.perInfo.sex
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('roles'),
      "value": _vm.perInfo.roles
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('mobile'),
      "value": _vm.perInfo.mobile
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "mint-cell"
  }, [_c('div', {
    staticClass: "mint-cell-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-wrapper"
  }, [_c('div', {
    staticClass: "mint-cell-title"
  }, [_c('span', {
    staticClass: "mint-cell-text"
  }, [_vm._v(_vm._s(_vm.$t('centerinfo_mac')))])]), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-value"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.perInfo.mac))])])]), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-right"
  })]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('centerinfo_version'),
      "value": _vm.perInfo.version
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('lastLoginDate'),
      "value": _vm.perInfo.lastLoginDate
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('lastIp'),
      "value": _vm.perInfo.lastIp
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-ac66b1f6","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/centerInfo.vue
// module id = 1831
// module chunks = 107